import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { AbstractService } from "./abstract.service";

import { environment } from "environments/environment";
import { Log } from "app/dto/log.dto";
import { Page } from "app/dto/page.dto";
import { AccionLogEnum } from "app/enums/accion-log.enum";
import * as moment from "moment";
import { LogHistorial } from "app/dto/log-historial.dto";

@Injectable({
  providedIn: "root",
})
export class LogService extends AbstractService<Log> {
  constructor(http: HttpClient) {
    super(http, environment.url_backend + "log");
  }

  paginado(
    page: number,
    size: number,
    idEntidad: string,
    nombreEntidad: string,
    accion: AccionLogEnum,
    fecha: string
  ) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("page", page.toString());
    httpParams = httpParams.set("size", size.toString());
    httpParams = httpParams.set("relations", "@usuario()");

    if (idEntidad) {
      httpParams = httpParams.set("idEntidad", idEntidad);
    }
    if (nombreEntidad) {
      httpParams = httpParams.set("nombreEntidad", nombreEntidad.trim());
    }
    if (accion) {
      httpParams = httpParams.set("accion", accion.trim());
    }
    if (fecha) {
      httpParams = httpParams.set("fecha", moment(fecha).format("YYYY-MM-DD"));
    }

    return this.http.get<Page>(this.urlServicio + "/paginado", {
      params: httpParams,
    });
  }

  historial(idEntidad: string, nombreEntidad: string, accion: AccionLogEnum) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("relations", "@usuario()");

    if (idEntidad) {
      httpParams = httpParams.set("idEntidad", idEntidad);
    }
    if (nombreEntidad) {
      httpParams = httpParams.set("nombreEntidad", nombreEntidad.trim());
    }
    if (accion) {
      httpParams = httpParams.set("accion", accion.trim());
    }

    return this.http.get<LogHistorial[]>(this.urlServicio + "/historial", {
      params: httpParams,
    });
  }
}
